export default "__VITE_ASSET__COBQ2nOd__"